import { Story, Knobs, Accents } from '../../DocTypes';

const multiCheckStoryKnobs: Knobs = {
  multiCheckAccent: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
    delimiter: '\n  ',
  },
  multiCheckAlign: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'left', 'right'],
    delimiter: '\n  ',
  },
  multiCheckSize: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'normal', 'large'],
    delimiter: '\n  ',
  },
  multiCheckRounded: { default: '', editor: 'checkbox', delimiter: '\n  ' },
  multiCheckSuppressSelectAll: { default: '', editor: 'checkbox', delimiter: '\n  ' },
  multiCheckSelectAllPosition: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'bottom', 'top'],
    delimiter: '\n  ',
  },
  multiCheckSelectAllLabel: {
    default: '',
    editor: 'textbox',
    delimiter: '\n  ',
  },
};

export const dataDrivenDisabledMultiCheckStory: Story = {
  title: 'Data driven disabled multi-check',
  description: 'List with items that that can be checked but some of them are disabled by data',
  coreComponent: {
    html: `<tag-list
    primary-field='name'
    secondard-field='description'
    multi-check
    multi-check-disabled-field='checkDisabled'{{multiCheckAccent}}{{multiCheckAlign}}{{multiCheckSize}}{{multiCheckRounded}}{{multiCheckSuppressSelectAll}}>
  </tag-list>`,
    js: `var tagList = document.querySelector('tag-list');
  tagList.componentOnReady().then(function() {
    tagList.setData([
      {
        name: 'Jordan Norry',
        description: "Should be enabled",
        checkDisabled: false
      },
      {
        name: 'Sarah Young',
        description: "Should be disabled",
        checkDisabled: true
      },
      {
        name: 'Susan Warmly',
        description: "Should be enabled",
        checkDisabled: false
      }
    ]);
  });
  `,
    knobs: multiCheckStoryKnobs,
  },
  reactWrapper: {
    jsx: `<TagList
    primaryField='name'
    data={[
      {
        name: 'Jordan Norry',
        description: "Should be enabled",
        checkDisabled: false
      },
      {
        name: 'Sarah Young',
        description: "Should be disabled",
        checkDisabled: true
      },
      {
        name: 'Susan Warmly',
        description: "Should be enabled",
        checkDisabled: false
      }
    ]}
    multiCheck
    multiCheckDisabledField='checkDisabled'{{multiCheckAccent}}{{multiCheckAlign}}{{multiCheckSize}}{{multiCheckRounded}}{{multiCheckSuppressSelectAll}}
  />`,
    knobs: multiCheckStoryKnobs,
  },
};
